<template>
    <div>
        <zm-row>
            <zm-button size="small" @click="showCreate()" class="btn-in-line" type="primary" v-if="hasPermission">create global config</zm-button>
            <zm-button size="small" @click="refreshData()" type="primary" class="btn-in-line" plain>refresh</zm-button>
        </zm-row>
        <div class="collapse-container">
            <zm-collapse v-model="collapseGroups" v-if="list.length" @change="refreshConfig" accordion>
                <zm-collapse-item v-for="item in list.slice((pageable.page - 1) * pageable.size, pageable.page * pageable.size)" :key="item" :name="item">
                    <template slot="title">
                        <span class="group-title">{{item}}</span>
                    </template>
                    <!-- <template slot-scope="scope"> -->
                        <transition name="fade">
                        <group-detail :group="item" ref="gmlist"></group-detail>
                        </transition>
                    <!-- </template> -->
                </zm-collapse-item>
            </zm-collapse>
            <div style="text-align: center" class="pagination-wrap">
                <zm-pagination
                    :current-page.sync="pageable.page"
                    :page-size="pageable.size"
                    layout="total, prev, pager, next, jumper"
                    :total="pageable.total">
                </zm-pagination>
            </div>
        </div>
        <zm-dialog :title="form.title" :visible.sync="dialogFormVisible">
            <zm-form :model="form" label-position="left" ref="form" :rules="rules">
                <zm-form-item label="configGroup" :label-width="formLabelWidth" prop="configGroup">
                    <div slot="label">
                        <tip label="configGroup" id="group-configGroup"></tip>
                    </div>
                    <zm-select size="small" v-model="form.configGroup" allow-create filterable class="config-select">
                        <zm-option v-for="item in list" :key="item" :value="item" :label="item"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="configName" :label-width="formLabelWidth" prop="configName">
                    <div slot="label">
                        <tip label="configName" id="group-configName"></tip>
                    </div>
                    <zm-select size="small" v-model="form.configName" allow-create filterable class="config-select">
                        <zm-option v-for="item in names" :key="item" :value="item" :label="item"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="configValue" :label-width="formLabelWidth">
                    <div slot="label">
                        <tip label="configValue" id="group-configValue"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="form.configValue"></zm-input>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="dialogFormVisible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="save()" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { getConfigList, createConfig, getConfigNames } from '../../api/globalconfig'
import groupDetail from './components/groupDetail'
import tip from 'components/ToolTip/index'
export default {
    name: 'group',
    components: {
        groupDetail, tip
    },
    data () {
        return {
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            collapseGroups: '',
            list: [],
            names: [],
            loading: false,
            pageable: {
                page: 1,
                size: 10,
                total: 0
            },
            dialogFormVisible: false,
            form: {
                title: '',
                configGroup: '',
                configName: '',
                configValue: ''
            },
            formLabelWidth: '100px',
            rules: {
                configGroup: [
                    { required: true, message: 'please enter configGroup', trigger: 'blur' }
                ],
                configName: [
                    { required: true, message: 'please enter configName', trigger: 'blur' }
                ]
            }
        }
    },
    created () {
        if (localStorage.params && localStorage.params !== 'undefined' && localStorage.path === this.$route.path) {
            this.collapseGroups = JSON.parse(localStorage.params).collapseGroups
        }
        localStorage.params = ''
        localStorage.path = this.$route.path
        this.fetchData()
        this.getNames()
    },
    watch: {
        collapseGroups () {
            this.setURL()
        }
    },
    methods: {
        setURL () {
            const { collapseGroups } = this
            const data = { path: this.$route.path, collapseGroups }
            localStorage.params = JSON.stringify(data)
        },
        setTime (row, column, cellValue, index) {
            let time = row[column.property]
            return new Date(parseInt(time)).toLocaleString()
            // return cellValue.split('T')[0] + ' ' + cellValue.split('T')[1].split('.')[0]
        },
        fetchData () {
            this.loading = true
            getConfigList().then(response => {
                this.list = response
                this.pageable.total = response.length
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        refreshData () {
            this.fetchData()
            this.$refs.gmlist.map(ref => {
                ref.fetchData()
            })
        },
        getNames () {
            getConfigNames().then(response => {
                this.names = response
            })
        },
        showCreate () {
            this.form.title = 'Create Global Config'
            this.form.configGroup = ''
            this.form.configName = ''
            this.form.configValue = ''
            this.dialogFormVisible = true
        },
        paginationChange () {
            this.fetchData()
        },
        handleSizeChange (val) {
            this.pageable.size = val
        },
        refreshConfig (activeName) {
            if (this.form.configGroup) {
                for (let i = 0; i < this.$refs.gmlist.length; i++) {
                    if (this.$refs.gmlist[i].group === this.form.configGroup) {
                        if (activeName === this.list[i]) {
                            this.$refs.gmlist[i].fetchData()
                        }
                    }
                }
            } else {
                for (let i = 0; i < this.$refs.gmlist.length; i++) {
                    if (activeName === this.list[i]) {
                        this.$refs.gmlist[i].fetchData()
                    }
                }
            }
        },
        save () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    const { configGroup, configName, configValue } = this.form
                    const data = { configGroup, configName, configValue }
                    if (this.form.title === 'Create Global Config') {
                        this.loading = true
                        createConfig(data).then(response => {
                            this.pageable.page = 1
                            this.fetchData()
                            this.$message({
                                message: 'Create config success!',
                                type: 'success'
                            })
                            this.dialogFormVisible = false
                            this.refreshConfig()
                            this.$refs.form.resetFields()
                        }).catch(() => {
                            this.loading = false
                        })
                    } else {
                        this.$message({
                            message: 'error!',
                            type: 'error'
                        })
                    }
                } else {
                    this.$message({
                        message: 'Submit error!',
                        type: 'error'
                    })
                    return false
                }
            })
        }
    }
}
</script>
<style scoped>
.btn-in-line{
    margin: 10px
}
.group-title {
    font-size: 17px;
    margin-left: 20px;
}
.config-select {
    width: 200px;
}
</style>
